var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcFileDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 0a.57.57 0 0 0-.571.571v5.446l-2.41-2.414a.596.596 0 1 0-.844.845l3.374 3.377c.124.124.289.182.451.174a.6.6 0 0 0 .451-.174l3.374-3.377a.598.598 0 0 0-.843-.845l-2.41 2.414V.57A.57.57 0 0 0 4 0M0 9.714a.57.57 0 0 1 .571-.571H7.43a.571.571 0 1 1 0 1.143H.57A.57.57 0 0 1 0 9.714"
})));
export default SvgIcFileDown;